<template>
  <div class="block-form">
    <q-input
      outlined
      :model-value="block.src"
      label="URL de imagen"
      @update:model-value="emit('update', { ...block, src: String($event ?? '') })"
    />
    <img
      v-if="block.src"
      :src="block.src"
      alt="Preview"
      class="image-preview"
    />
    <q-input
      outlined
      :model-value="block.alt"
      label="Texto alternativo"
      @update:model-value="emit('update', { ...block, alt: String($event ?? '') })"
    />
    <q-input
      outlined
      :model-value="block.caption"
      label="Pie de imagen (opcional)"
      @update:model-value="emit('update', { ...block, caption: String($event ?? '') })"
    />
  </div>
</template>

<script setup lang="ts">
interface ImageBlock {
  type: 'image';
  src: string;
  alt?: string;
  caption?: string;
}

const props = defineProps<{ block: ImageBlock }>();
const emit = defineEmits<{ (e: 'update', block: ImageBlock): void }>();

void props;
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.image-preview {
  max-height: 200px;
  width: auto;
  max-width: 100%;
  border-radius: 8px;
  border: 1px solid var(--oa-border);
  object-fit: cover;
}
</style>
